import { z } from 'zod'
import {
  AccountStatusIdSchema,
  idSchemaV1,
  isId,
  WorkflowActionIdSchema,
  WorkflowIdSchema,
  WorkflowStageIdSchema,
} from '../ids'
import { AuditPropsSchema } from '../common'

export const WebhookIdSchema = idSchemaV1('Webhook')
export type WebhookId = z.infer<typeof WebhookIdSchema>
export const isWebhookId = isId(WebhookIdSchema)

export const WEBHOOK_TARGETS = ['ENERFLO', 'SALESFORCE', 'JOBNIMBUS', 'SERVICETITAN', 'CONNECT'] as const
export const WebhookTargetSchema = z.enum(WEBHOOK_TARGETS)
export type WebhookTarget = z.infer<typeof WebhookTargetSchema>

export const TERROS_SAMPLE_WEBHOOK_URL = 'https://terros.com/test'

export const WEBHOOK_ENTITIES = [
  'Account',
  'Company',
  'Contact',
  'Evaluation',
  'Event',
  'Screenshot',
  'Task',
  'Team',
  'User',
] as const
export const WebhookEntitySchema = z.enum(WEBHOOK_ENTITIES)
export type WebhookEntity = z.infer<typeof WebhookEntitySchema>

export const CustomWebhookParamsSchema = z.record(
  z.string(),
  z.union([z.string(), z.number(), z.record(z.string(), z.unknown())])
)
export type CustomWebhookParams = z.infer<typeof CustomWebhookParamsSchema>

export const UnsavedWebhookDataSchema = z.object({
  entity: WebhookEntitySchema,
  url: z.string(),
  target: WebhookTargetSchema.nullable().optional(),
  headers: z.record(z.string(), z.string()).optional(),
  name: z.string().optional(),
  description: z.string().optional(),
  add: z.boolean().optional(),
  update: z.boolean().optional(),
  remove: z.boolean().optional(),
  params: CustomWebhookParamsSchema.optional(),
  statusIds: z.array(AccountStatusIdSchema).optional(),
  workflowId: WorkflowIdSchema.optional(),
  workflowStageIds: WorkflowStageIdSchema.array().optional(),
  workflowActionIds: WorkflowActionIdSchema.array().optional(),
  failureRecipients: z.array(z.email()).optional(),
})
export type UnsavedWebhookData = z.infer<typeof UnsavedWebhookDataSchema>

export const WebhookDataSchema = z.object({
  ...AuditPropsSchema.shape,
  ...UnsavedWebhookDataSchema.shape,
  webhookId: WebhookIdSchema,
})
export type WebhookData = z.infer<typeof WebhookDataSchema>
